var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGecoIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_1039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33337 14.0833C6.26506 14.3128 8.06334 15.1856 9.43886 16.5611C10.8144 17.9366 11.6871 19.7349 11.9167 21.6666C12.8743 21.1145 13.6753 20.3274 14.244 19.3796C14.8126 18.4318 15.1302 17.3546 15.1667 16.2499C16.9857 15.61 18.5742 14.4451 19.7312 12.9024C20.8882 11.3598 21.5617 9.5087 21.6667 7.58325C21.6667 6.7213 21.3243 5.89465 20.7148 5.28515C20.1053 4.67566 19.2787 4.33325 18.4167 4.33325C16.4913 4.43824 14.6402 5.11181 13.0975 6.26879C11.5549 7.42578 10.39 9.01422 9.75004 10.8333C8.64533 10.8697 7.56816 11.1873 6.62036 11.756C5.67256 12.3247 4.88543 13.1257 4.33337 14.0833Z",
    stroke: "#1733E1",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58328 15.1667C6.45578 15.8033 5.54408 16.762 4.96504 17.9201C4.386 19.0782 4.16601 20.3828 4.33328 21.6667C5.61721 21.834 6.92183 21.614 8.07991 21.035C9.23799 20.456 10.1967 19.5442 10.8333 18.4167",
    stroke: "#1733E1",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 9.75008C15.1666 10.0374 15.2808 10.3129 15.4839 10.5161C15.6871 10.7193 15.9626 10.8334 16.25 10.8334C16.5373 10.8334 16.8128 10.7193 17.016 10.5161C17.2192 10.3129 17.3333 10.0374 17.3333 9.75008C17.3333 9.46276 17.2192 9.18721 17.016 8.98405C16.8128 8.78088 16.5373 8.66675 16.25 8.66675C15.9626 8.66675 15.6871 8.78088 15.4839 8.98405C15.2808 9.18721 15.1666 9.46276 15.1666 9.75008Z",
    stroke: "#1733E1",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_1039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGecoIcon1);
export default __webpack_public_path__ + "static/media/geco_Icon1.eae9560940dbdec5eed632d97e7156c6.svg";
export { ForwardRef as ReactComponent };